"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpFilterLine = void 0;
const gs = require("@ivanlog/gs");
const App_1 = require("../App");
const tmpls_1 = require("./tmpls");
const ClassesTags_1 = require("../ClassesTags");
const SearchController_1 = require("../appControllers/SearchController");
class CmpFilterLine extends tmpls_1.CmpFilterLineBase {
    constructor() {
        super();
        this._inCatalog = false;
        const searchCtrl = App_1.App.Inst.getInst(SearchController_1.SearchController);
        this.ctrls.btnFilterInStock.onclick = () => {
            this.ctrls.cbFilterInStock.flipClass(ClassesTags_1.ClassesTags.Active);
            searchCtrl.filterInStock = this.isFilterInStock;
            searchCtrl.refreshQuery();
        };
        this.ctrls.btnResetFilters.onclick = () => {
            //TODO очистка других фильтров
            if (!this._inCatalog)
                searchCtrl.filterCategory = 0;
            this.fillAsync();
            searchCtrl.refreshQuery();
        };
        const options = [];
        const docClickHandler = (e) => {
            if (options.indexOf(e.target) < 0) {
                document.removeEventListener("click", docClickHandler);
                this.ctrls.optionsList.hide();
            }
        };
        this.ctrls.optionsSelected.onclick = (e) => {
            gs.events.stop(e);
            if (this.ctrls.optionsList.isShowed)
                return;
            this.ctrls.optionsList.show();
            document.addEventListener("click", docClickHandler);
        };
        for (const option of this.ctrls.optionsList.q('.option_item').all) {
            options.push(option.el);
            option.onclick = () => {
                this.ctrls.optionsSelected.text = option.text;
                this.ctrls.optionsList.hide();
                document.removeEventListener("click", docClickHandler);
                searchCtrl.sortType = parseInt(option.getData('sort'));
                searchCtrl.refreshQuery();
            };
        }
    }
    setInCatalogMode() {
        this._inCatalog = true;
    }
    get isFilterInStock() { return this.ctrls.cbFilterInStock.hasClass(ClassesTags_1.ClassesTags.Active); }
    fillAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const searchCtrl = App_1.App.Inst.getInst(SearchController_1.SearchController);
            this.ctrls.cbFilterInStock.removeClass(ClassesTags_1.ClassesTags.Active);
            this.ctrls.optionsSelected.text = this.ctrls.optionsList.q(`[data-sort="${searchCtrl.sortType}"]`).first.text;
            if (searchCtrl.filterInStock)
                this.ctrls.cbFilterInStock.addClass(ClassesTags_1.ClassesTags.Active);
            if (!this._inCatalog && searchCtrl.filterCategory) {
                const category = yield App_1.App.Inst.cache.getCategoryAsync(searchCtrl.filterCategory);
                this.ctrls.blockFilterTags.show();
                const tag = gs.w(gs.html.tag("button", { class: "tag" }, category.name));
                tag.onclick = () => { searchCtrl.filterCategory = 0; this.fillAsync(); searchCtrl.refreshQuery(); };
                this.ctrls.listFilterTags.append(tag);
            }
            else
                this.ctrls.blockFilterTags.hide();
        });
    }
    setInSearch() {
        this.ctrls.lFoundedCount.text = 'Поиск...';
    }
    setSearchResult(count) {
        this.ctrls.lFoundedCount.text = 'Найдено ' + count;
    }
}
exports.CmpFilterLine = CmpFilterLine;
//# sourceMappingURL=CmpFilterLine.js.map